import * as THREE from 'three';
import { OrbFactory } from '../../../orbs/OrbFactory';
export function addSimpleOrbs(scene, configs) {
    configs.forEach(cfg => {
        var _a;
        const orb = OrbFactory.createOrbByType(cfg.type, cfg.label);
        if (!orb)
            return;
        orb.setPosition(cfg.position.clone());
        (_a = cfg.configure) === null || _a === void 0 ? void 0 : _a.call(cfg, orb);
        orb.addToScene(scene);
    });
}
export function createPortalOrb(config) {
    var _a, _b;
    const orb = OrbFactory.createOrbByType('SYSTEM_ORB', config.label);
    if (!orb)
        return null;
    orb.orbConfig.isPortal = true;
    orb.orbConfig.portalLayer = 'inner';
    orb.orbConfig.portalTargetSceneName = config.target;
    if (config.slug) {
        orb.orbConfig.portalTargetWorldSlug = config.slug;
    }
    orb.orbConfig.portalResolution = (_a = config.resolution) !== null && _a !== void 0 ? _a : 384;
    orb.orbConfig.portalCameraFOV = (_b = config.fov) !== null && _b !== void 0 ? _b : 65;
    if (typeof orb.orbConfig.radius === 'number') {
        orb.orbConfig.radius = orb.orbConfig.radius * 0.5;
    }
    orb.setPosition(config.position.clone());
    return orb;
}
export function addPortalOrbs(scene, configs) {
    configs.forEach(cfg => {
        const orb = createPortalOrb(cfg);
        if (!orb)
            return;
        orb.addToScene(scene);
    });
}
export function addWorldBoundarySphere(scene, radius, options = {}) {
    var _a, _b, _c;
    const detail = Math.max(1, Math.min(6, (_a = options.segments) !== null && _a !== void 0 ? _a : 4));
    const geometry = new THREE.IcosahedronGeometry(radius, detail);
    const edges = new THREE.EdgesGeometry(geometry);
    const material = new THREE.LineBasicMaterial({
        color: (_b = options.color) !== null && _b !== void 0 ? _b : 0x4a90e2,
        transparent: true,
        opacity: (_c = options.opacity) !== null && _c !== void 0 ? _c : 0.35,
        depthWrite: false,
    });
    const wireframe = new THREE.LineSegments(edges, material);
    wireframe.frustumCulled = false;
    scene.add(wireframe);
    return wireframe;
}
